import React, {useState, useEffect, useRef} from 'react'
import {  Grid, Table, TableCell, Button, TableBody, TableHead, IconButton, Menu, TableRow, Box, Typography, Card, MenuItem, TableContainer, Stack,Accordion, AccordionSummary, AccordionDetails, CardContent } from "@mui/material" ;
import { profileSettingStyles } from '../../../styles/materialComponent';
import { CssTextField , CssButton} from '../../../styles/materialComponent';
import {useSelector, useDispatch} from "react-redux"
import {fetchClientType, editClientData} from "../../../actions/client"
import { useNavigate } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Phone from '../../../components/common/phone'
import { Autocomplete, useJsApiLoader } from '@react-google-maps/api'
import { validateUserType } from '../../../ValidateUserType';
import { fetchArbors } from '../../../actions/arboristLogin';

const clientContacts =[
  "Name",
  "Email",
  "PhoneNo",
  "Action"
]
const libraries = ['places'];

const EditClient = () => {   
  const autocompleteRef = useRef(null)

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [open, setOpen] = useState(false)
    const [selectedItemRow, setSelectedRow] = useState(null)
    const [expanded, setExpanded] = useState(false)
    const [edit, setEdit] = useState(false)
    const [error, setError] = useState('')
    const [idItem, setIdItem] = useState(null)
    const classes = profileSettingStyles()
    const [anchorEl, setAnchorEl] = useState(null);
    const {client, clientTypes} = useSelector(({client})=>client)
    const {arbors}=useSelector(({arbor})=>arbor)

    const [clientData, setClientData] = useState({
      clientName: client?.clientName ? client.clientName : "",
      address: client?.address ? client?.address : "",
      clientType: client?.clientType?._id ? client?.clientType?._id: "",
      clientLat:client?.clientLocation?.coordinates[1],
      clientLong:client?.clientLocation?.coordinates[0],
      slectArbor:client?.arborist ? client.arborist : ""
    })
    const [state, setState] = useState({
      name:  "",
      email: "",
      phone: "",
      countryCode: ""
    })

    const [contact, setContact] = useState([])

  
    useEffect(()=>{
      setContact(client?.contacts)
    },[])

    useEffect(()=>{
      if(validateUserType()){
        dispatch(fetchArbors())
      }
      dispatch(fetchClientType())
    },[])


    const { isLoaded, loadError } = useJsApiLoader({
      googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
      libraries
  });
  
    const onLoadAutocomplete = (autocomplete) => {
      autocompleteRef.current = autocomplete;
  }
  const onPlaceChanged = () => {
    const  place  = autocompleteRef.current.getPlace();
    if(place) { 
      const lat = place.geometry.location.lat()
      const lng = place.geometry.location.lng() 
      setClientData({...clientData, address: place.formatted_address, clientLat:lat, clientLong:lng })
    } 
  }
    const handleChange =(e)=>{
      const {name, value} = e.target
      setClientData({...clientData, [name]:value})
    }
    function isValidEmail(email) {
      return /\S+@\S+\.\S+/.test(email);
    }

    const handleContactChange =(e)=>{
      const {name, value} = e.target
      if(name === "email"){
        if(!isValidEmail(e.target.value)){
          setError("email is not valid")
        }else{
          setError("")
        }
      }  
      setState({...state, [name]:value})
    }
    
    const handlePhoneInput = (v, code) => {
      setState({...state, phone:v, countryCode:code})
    };

    function handleCloses() {
      setAnchorEl(null);
      setSelectedRow(null) 
    }

    const handleClose = () => {
      setOpen(false);
    };
  
    const handleOpen =()=>{
      setExpanded(!expanded);
    }

    function handleClick(event, row) {
      setAnchorEl(event.currentTarget);
      setSelectedRow(row)
    }
   

    const handleEdit =(row)=>{
      setExpanded(true)
      const updatedItems = contact.find(item => {
        return item._id ? item?._id === row : item.key === row 
      })
      setState(updatedItems)       
      setIdItem(row)
      setEdit(true)
      handleCloses()
    }

    const handleDelete =(index)=>{
      const updateList = contact.filter((elem)=>{
        return elem?._id ? index!== elem._id : index!==elem.key
      })
      setContact(updateList)   
       }

    const handleContactSubmit = (e)=>{
    e.preventDefault()    
    if(edit){
      setContact(contact.map((item)=>{
        if(item?._id === idItem || item.key === idItem){
          return {...item, name:state.name, email: state.email,
            phone: state.phone,
            countryCode: state.countryCode}
        }
        return item
      }))
      setEdit(false)
      clear()
    }else{
        const inputData =
          {
            key: new Date().getTime().toString(), 
            name:state.name, email: state.email,
            phone: state.phone,
            countryCode: state.countryCode
          }
          setContact([...contact, inputData])
          clear()    
    }   
    }

    const handleSubmit =(e)=>{
      e.preventDefault()
       if(validateUserType() && !clientData.slectArbor){
        NotificationManager.error("All fields are required")
       }
      if(!clientData.clientName || !clientData.address || !clientData.clientType){
        NotificationManager.error("All fields are required")
      }else{
        const data = {
          clientName: clientData.clientName,
          address: clientData.address,
          clientType: clientData.clientType,
          clientLat:clientData.clientLat,
          clientLong: clientData.clientLong, 
          contacts:contact
        }
        dispatch(editClientData(data, navigate))
      }
    }

    const clear =()=>{
      setState({
        name:"",
        email:"",
        phone:"",
        countryCode:""
      })
    } 
    
    if (!isLoaded) {
      return <div>Loading...</div>;
    }

  return (
      <Grid container justifyContent="center">
      <Grid item xs={12} sm={12} md={8} lg={8}>
      <Card
        style={{boxShadow: "0 2px 4px 0 rgba(0,0,0,.2)", borderRadius:8, backgroundColor:"#FCFBFD"}}
      >    
      <CardContent>
      <Box className={classes.profileText}>
        <Typography variant="h4" fontFamily="CormorantBoldItalic" style={{marginTop:50}}>Edit Client</Typography>
      </Box>
        <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>

        {validateUserType() &&  <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <CssTextField
          required
          select
          className={classes.textField1}
          variant="outlined"
          label="Select Arbor"
          name="slectArbor"
          value={clientData.slectArbor!==""?clientData.slectArbor:""}
          onChange={handleChange}
        >
          <MenuItem disabled value="">
            <em>None</em>
          </MenuItem>
          {arbors.length>0 && arbors.map((op)=>op._id===clientData.slectArbor?
            <MenuItem disabled value={op._id}>{op.firstName}</MenuItem>:null
          )}
      </CssTextField>
      </Grid>}
        
       <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <CssTextField        
          className={classes.textField1}
          required
          variant="outlined"
          label="Client Name"    
          name="clientName" 
          value={clientData.clientName}
          onChange={handleChange}    
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid} >
      <div className={classes.textField1}>
       <Autocomplete
          onLoad={onLoadAutocomplete}
          onPlaceChanged={onPlaceChanged}
        >
      <CssTextField
        style={{width:"100%"}}
        variant="outlined"
        label="Address"
        type='text'
        name="address"
        value={clientData.address}
        onChange={handleChange} 
      />
      </Autocomplete>
      </div>
      </Grid>
       {/* <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <CssTextField
          required
          className={classes.textField1}
          variant="outlined"
          label="Address"   
          name="address"       
          value={clientData.address}
          onChange={handleChange} 
        />
      </Grid> */}
      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <CssTextField
          required
          select
          className={classes.textField1}
          variant="outlined"
          label="Client Type"   
          name="clientType"       
          value={clientData.clientType}
          onChange={handleChange} 
        >
          <MenuItem disabled value="">
            <em>None</em>
          </MenuItem>
          {clientTypes?.length && clientTypes.map((op)=>          
          <MenuItem value={op._id}>{op.name}</MenuItem>
          )}
      </CssTextField>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>  
        <Card sx={{backgroundColor:"#FCFBFD"}}  className={classes.textField1}> 
         <TableContainer>
        <Table  aria-label="simple table">
        <TableHead >
          <TableRow>
        {
          clientContacts?.map((tab, index)=>        
            <TableCell align="left" variant="h4">{tab}</TableCell>
          )
        }
            </TableRow>
            </TableHead>
            <TableBody>             
            {contact?.length ? contact?.map((row)=> 
                <TableRow>                  
                <TableCell>
                  {row.name}
                </TableCell>
                <TableCell>{row.email}</TableCell>
                <TableCell>{row.phone}</TableCell>
                <TableCell>
                <Box>
                  <IconButton
                    aria-label="More"
                    aria-owns={open ? "long-menu" : undefined}
                    aria-haspopup="true"
                    onClick={(event)=>handleClick(event, row)}
                    style={{backgroundColor:"gray", color:"white", borderRadius:"4px", padding:7}}
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    open={Boolean(anchorEl && selectedItemRow === row)}
                    id="long-menu"
                    anchorEl={anchorEl}
                    onClose={handleCloses}
                  >
                      <MenuItem onClick={handleClose} >
                      <IconButton onClick={()=>handleEdit(row?._id? row?._id : row.key)}>
                      <EditIcon /><Typography style={{marginLeft:5}}>Edit</Typography>
                      </IconButton>
                      </MenuItem>
                      <MenuItem onClick={handleClose} >
                      <IconButton  onClick={()=>handleDelete(row?._id? row?._id : row.key)}>
                      <DeleteIcon /><Typography style={{marginLeft:5}}>Delete</Typography>
                        </IconButton>
                      </MenuItem>
                     
                  </Menu>
              </Box>              
                </TableCell> 
                {/* <TableCell>Test</TableCell> */}
            </TableRow>   
              ):null}
            </TableBody>   
            </Table>
            </TableContainer> 
        </Card></Grid>
      <div className={classes.grid} style={{marginLeft:22, marginTop:20}}>
      <Accordion className={classes.textField1} expanded = {expanded} style={{ backgroundColor:"#FCFBFD"}}> 
        <AccordionSummary
          expandIcon={<ExpandMoreIcon/>}
          onClick = {handleOpen}
          aria-controls= "panel1a-content" 
          id="panel1a-header"
        >
          <Typography style={{color:"rgba(0, 0, 0, 0.6)"}}>Edit Contact Details</Typography>
        </AccordionSummary>
        <AccordionDetails>
        <Grid container spacing={3} style={{padding:10}}>
        <Grid item xs={12} sm={12} md={12} lg={12}>     
             <CssTextField
              fullWidth        
              required
              variant="outlined"
              label="Name"    
              name="name" 
              value={state.name}
              onChange={handleContactChange}    
            />
             </Grid>
             <Grid item xs={12} sm={12} md={12} lg={12} >     
             <CssTextField
              fullWidth        
              required
              variant="outlined"
              label="Email"    
              name="email" 
              value={state.email}
              onChange={handleContactChange}    
            />
            {error ? <div style={{color:"red"}}>{error}</div>: null}
             </Grid>
             <Grid item xs={12} sm={12} md={12} lg={12} >     
             <Phone
                fullWidth                
                required
                variant="outlined"
                label="Phone No"    
                name="phone" 
                value={state.phone}
                onChange={(v, code) => handlePhoneInput(v, code)}
                // onChange={(e)=>handleContactChange(e, index, "phone")}    
              />
             </Grid>
             <Grid item xs={12} sm={12} md={12} lg={12} >
            <Button
              style={{backgroundColor:(state.name && state.email && state.phone && !error) && "rgb(115 74 153)"}}
              fullWidth
              size="large"
              variant="contained"
              onClick={handleContactSubmit}
              disabled={state.name && state.email && state.phone && !error ? false : true }
            >
              Save
            </Button>
            </Grid>
        </Grid>
        </AccordionDetails>
      </Accordion>  
       </div>    
       <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <CssButton
          // className={classes.submitButton1}
          style={{backgroundColor:"rgb(115 74 153)"}}
          size="large"
          variant="contained"
          onClick={handleSubmit}
        >
          Edit
        </CssButton>       
        <CssButton
          // type="reset"
          className={classes.cancelButton1}
          sx={{backgroundColor:"lightgray", color:"black", marginLeft:4}}          
          size="large"
          variant="contained"
          onClick={()=>navigate(-1)}
        >
          Back
        </CssButton>
        </Grid>
      </Grid>
      </CardContent>
    
         
    </Card>
    </Grid>
    </Grid>


  )
}

export default EditClient